import React from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';

import CardOfCase from '../CardOfCase';
import SearchCases from '../SearchCases';
import HeaderPanel from '../HeaderPanel';
import InfoBlock from '../InfoBlock';

import { formatDate, formatComment, formatNull, getCaseStyle, formatOverflow } from '../../Utils/GlobalUtils';
import { useModal } from '../Modal/ModalContext';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';

import headerPanel from '../../styles/HeaderPanel.module.css';

const AdministrationManagerTable = ({ nameOfLabel, setNameOfLabel }) => {
    const { openModal } = useModal();
    const [searchParams, setSearchParams] = useSearchParams();

    const [idCaseForModal, setIdCaseForModal] = React.useState('');
    const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);
    const [isSearch, setIsSearch] = React.useState(false);

    const [limitForView, setLimitForView] = React.useState(10);
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [miniLoading, setMiniLoading] = React.useState(false);
    const [reload, setReload] = React.useState(true);
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    React.useEffect(() => {
        setReload(true);
    }, [nameOfLabel]);

    // Функции для работы с куки
    const [onlyPersonalCases, setOnlyPersonalCases] = React.useState(false);
    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    const getCookie = (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    React.useEffect(() => {
        const savedValue = getCookie('onlyPersonalCases');
        if (savedValue !== null) {
            setOnlyPersonalCases(savedValue === 'true');
        }
    }, []);

    // Открытие модального окна, если параметр case присутствует в URL
    React.useEffect(() => {
        const caseIdFromUrl = searchParams.get('case');
        if (caseIdFromUrl) {
            setIdCaseForModal(caseIdFromUrl);
            setIsCardOfCaseModal(true);
        }
    }, [searchParams]);

    const [lastUpdateTime, setLastUpdateTime] = React.useState('--:--');

    React.useEffect(() => {
        setMiniLoading(true);
        const token = localStorage.getItem('token');
        axios.get(`/api/cases?limitForView=${limitForView}&nameOfLabel=${nameOfLabel}&onlyPersonal=${onlyPersonalCases}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Таблица пуста.');
                setCases([]);
                setVisibilityBtn(false);
            } else {
                setWarning('');
                setCases(response.data);
                setVisibilityBtn(response.data.length >= limitForView);
            }

            const currentTime = new Date();
            const formattedTime = currentTime
                .toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
            setLastUpdateTime(formattedTime);
        })
        .catch(error => {
            if (error.response?.data.action == 'logout') {
                localStorage.removeItem('token');
                window.location.href = '/auth/login';
            }
            setWarning(`Ошибка при загрузке таблицы:  ${error.response?.data.message || error.message}`);

            setLastUpdateTime('--:--');
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
            setMiniLoading(false);
        });
    }, [reload]);

    const colorsDescriptionModal = 
    <form>
        <div style={{display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '.5em', boxSizing: 'border-box', border: '1px solid rgb(56, 0, 0)', backgroundColor: 'rgb(255, 240, 240)', marginBottom: '5px'}}>
            <a style={{margin: '0'}}>Судебное заседание прошло, но в карточке отсутствует дата назначения арбитражного управляющего.</a>
        </div>
        <div style={{display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '.5em', boxSizing: 'border-box', border: '1px solid blue', backgroundColor: 'rgb(235, 245, 255)', marginBottom: '5px'}}>
            <a style={{margin: '0'}}>Карточка не заполнена, отсутствует сформированная конечная дата.</a>
        </div>
        <div style={{display: 'flex', alignItems: 'center', padding: '10px', borderRadius: '.5em', boxSizing: 'border-box', border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)'}}>
            <a style={{margin: '0'}}>Исполнение этапа не проведено в срок.</a>
        </div>
    </form>;

    const handleOnlyPersonalCasesChange = (e) => {
        const newValue = e.target.checked;
        setOnlyPersonalCases(newValue);
        setCookie('onlyPersonalCases', newValue, 30);
        setReload(true);
    };

    return (
        <>
        {isCardOfCaseModal && <CardOfCase closeModal={() => {setIsCardOfCaseModal(false); setSearchParams({});}} id={idCaseForModal} onCardOfCaseSuccess={() => {setReload(true)}} />}
        {isSearch && <SearchCases closeModal={() => {setIsSearch(false)}} type={nameOfLabel} />}
            
        <div className='mainContainer'>
            <InfoBlock />
            <h1>{nameOfLabel}</h1>
            <HeaderPanel typePanel='Администратор' onAddNewCaseSuccess={() => setReload(true)} nameOfLabel={nameOfLabel} setNameOfLabel={setNameOfLabel} />
            <div className={headerPanel.additionalPanel}>
                <div className={headerPanel.searchBtn} onClick={(e) => {e.preventDefault(); setIsSearch(true)}}>Поиск...</div>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span className={headerPanel.tumblerPanel}>
                        <a>Свои карточки</a>
                        <div className='checkboxWrapper'>
                            <label className='switch' htmlFor='onlyPersonalCases'>
                                <input 
                                    type='checkbox' 
                                    id='onlyPersonalCases' 
                                    checked={onlyPersonalCases}
                                    onChange={handleOnlyPersonalCasesChange}
                                />
                                <div className='slider round'></div>
                            </label>
                        </div>
                    </span>

                    {nameOfLabel=='Входящая корреспонденция' && 
                        <Link to='/inbox' className='button' style={{marginLeft: '10px'}}>Уведомления</Link>
                    }
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '5px', zIndex: '2'}}>
                <div onClick={() => {openModal('Обозначения цветов таблицы', colorsDescriptionModal)}} style={{marginRight: '12px'}} className='textButton'>Обозначения</div>
                <a style={{display: 'flex', alignItems: 'center'}}>Последнее обновление таблицы: {lastUpdateTime} {miniLoading && <Loading widthParam='mini' />}</a>
            </div>
            <div className='tableContainer'>
                <div className='tableHeader'>
                    <a className='numberCase'>Номер</a>
                    <a className='categoryCase'>Категория</a>
                    <a className='applicantCase'>Должник и регион</a>
                    <a className='dateSendCandidateCase'>Дата отправки кандидатуры</a>
                    <a className='dateCourtCase'>Дата судебного заседания</a>
                    <a className='dateAMAppointmentCase'>Дата назначения</a>
                    <a className='datesCase'>Начальная дата / Конечная дата текущего этапа</a>
                    <a className='statusCase'>Статус</a>
                </div>
                {loading ? <LoadingLines />
                : warning ? <div className='case warningLine'><a>{warning}</a></div> 
                : cases.map((caseItem) => (
                    <motion.div
                        initial={{ scale: '97%', opacity: 0 }}
                        animate={{ scale: '100%', opacity: 1 }}
                        exit={{ scale: '97%', opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <div className='case' style={getCaseStyle(caseItem.date_end, caseItem.date_court, caseItem.date_am_appointment, caseItem.status)} key={caseItem.id} onClick={() => { setIsCardOfCaseModal(true); setIdCaseForModal(caseItem.id); setSearchParams({ case: caseItem.id });}}>
                            <a className='numberCase'>{formatNull(caseItem.number)} {caseItem.nameLabel=='Жалоба' && '(Жалоба)'} <span style={{color: 'rgb(169, 169, 169)'}}>{caseItem.internal_number}</span></a>
                            <a className='categoryCase'>{formatNull(formatOverflow(caseItem.nameCategory))}</a>
                            <a className='applicantCase'>{formatNull(caseItem.applicant)} {formatNull(caseItem.region)}</a>
                            <a className='dateSendCandidateCase'>{formatDate(caseItem.date_submission_candidate)}</a>
                            <a className='dateCourtCase'>{formatDate(caseItem.date_court)}</a>
                            <a className='dateAMAppointmentCase'>{formatDate(caseItem.date_am_appointment)}</a>
                            <a className='datesCase'>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_end)}</a>
                            <a className='statusCase' style={{ borderBottom: 'none', borderRight: 'none' }}>{caseItem.status}</a>
                        </div>
                    </motion.div>
                ))}
                {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 10); setReload(true)}}>Загрузить ещё</button></span>}
            </div>
        </div>
        </>
    );
}

export default AdministrationManagerTable;
